// --------------------------------------------------------
// AGENDA MES LIST ITEM - AgendaMesListItem
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Table } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import Colors from '../../constants/Colors'
import { StyledSwitch } from '../companyListItem/CompanyListItem.styled'
import { ListItemContainer, TableData, TextLink, Text } from '../UI/generalLayout/Layout.styled'
import { Paths } from '../../enums/Paths'
import { useNavigate } from 'react-router-dom'
import { UnitService } from '../../core/http/service/UnitService'
import Unit from '../../models/core/unit/Unit'
import ActivateInactivateModal from '../activateInactivateModal/ActivateInactivateModal'
import AgendaMes from '../../models/core/agenda/AgendaMes'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { MobileContainer } from '../companyListItem/CompanyListItemMobile.styled'
import { RowContainer } from '../../pages/careLine/CareLine.styled'
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// AGENDA MES LIST ITEM INTERFACE
// --------------------------------------------------------

interface IAgendaMesListItem {
    mes: any;
    nomeProfissional: string;
    agenda: AgendaMes;
    onActivateInactivate: any;
    profissionalInfo: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AgendaMesListItem = ({ mes, profissionalInfo, agenda, nomeProfissional, onActivateInactivate }: IAgendaMesListItem) => {
    // --------------------------------------------------------
    // AGENDA MES LIST ITEM PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const [unitList, setUnitList] = useState<any[]>([])
    const [showModalInactivate, setShowModalInactivate] = useState(false)
    const [isActive, setIsActive] = useState(!agenda.inativo);
    const  { isMobile } = useResponsiveInfo();

    const fillUnitList = useCallback(async () => {
        const unitService: UnitService = new UnitService();
        const retorno: any = await unitService.getUnitById(agenda.unidadeAtendimentoId ?? '')
        const unidade: Unit = new Unit().fromJSON(retorno.data.data)
        setUnitList(prev => [unidade])
    }, [agenda])

    useEffect(() => {
        fillUnitList()
    }, [mes])

    const navigate = useNavigate()

    const navigateToMonthDetail = () => {
        return navigate(Paths.AgendasMes, { state: { profissionalInfo: profissionalInfo , mesFormatado: `${mes.mesDescricao} de ${mes.ano}`, agenda: { ...agenda, unidade: unitList } }})
    }

    const onChangeSwitchValue = (event: any) => {
        setShowModalInactivate(true)
    }

    const activateOrInactivateAgendaMes = async (event: any) => {
        try {
            onActivateInactivate()
            setIsActive(prev=>!prev)
            setShowModalInactivate(false)
        } catch (error: any) {

        }
    }
    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <ListItemContainer disabled={!isActive}>
                {!isMobile? (<Table>
                    <TableData width={'20%'} style={{ verticalAlign: 'middle' }}>
                        <div style={{ flexDirection: 'row', display: 'flex' }}>
                            <div>
                                <Text bold style={{ fontSize: 14 }}>{`${mes.mesDescricao} de ${mes.ano}`}</Text>
                            </div>
                        </div>
                    </TableData>
                    <TableData width={'20%'} style={{ verticalAlign: 'middle' }}>
                        <div style={{ flexDirection: 'row', display: 'flex' }}>
                            {unitList.map((unit: Unit, index: number) => {
                                return <Text key={index} bold>{unit.nomeFantasia}</Text>
                            })}
                        </div>
                    </TableData>
                    <TableData width={'20%'} style={{ verticalAlign: 'middle' }}>
                        <TextLink style={{ marginTop: 10, marginLeft: 40, fontWeight: 'bold', color: Colors.SPM500 }} onClick={navigateToMonthDetail}>{`VER AGENDAS DO MÊS > `}</TextLink> {/** Empresa */}
                    </TableData>
                    <TableData width={'5%'} style={{ verticalAlign: 'middle' }}>
                        <StyledSwitch
                            sx={{ width: 60, opacity: agenda.ativavel? '1':'0.5' }}
                            style={{ color: Colors.SPM600, width: 45 }}
                            checked={isActive}
                            onChange={!agenda.ativavel? ()=>{} : onChangeSwitchValue}
                        />
                    </TableData>
                </Table>)
                :(<MobileContainer>
                    <div style={{ width: '100%'}}>
                        <Text bold style={{ fontSize: 14 }}>{`${mes.mesDescricao} de ${mes.ano}`}</Text>
                        {unitList.map((unit: Unit, index: number) => {
                                return <Text key={index} bold style={{ marginTop: -5 }}>{unit.nomeFantasia}</Text>
                        })}
                        <TextLink style={{ fontWeight: 'bold', color: Colors.SPM500 }} onClick={navigateToMonthDetail}>{`VER AGENDAS DO MÊS > `}</TextLink> {/** Empresa */}
                    </div>
                    <StyledSwitch
                        sx={{ width: 60, marginTop: 2, opacity: agenda.ativavel? '1':'0.5' }}
                        style={{ color: Colors.SPM600, width: 45 }}
                        checked={isActive}
                        onChange={!agenda.ativavel? ()=>{} : onChangeSwitchValue}
                    />
                </MobileContainer>)}
            </ListItemContainer>

            <ActivateInactivateModal
                isActivate={!isActive}
                visible={showModalInactivate}
                onCancel={() => { setShowModalInactivate(false); }}
                onConfirmCancellation={activateOrInactivateAgendaMes}
                ativarButtonMsg={`Ativar`}
                inativarButtonMsg={`Desativar`}
                modalMsg={`Tem certeza que deseja ${isActive? 'desativar':'ativar'} a agenda do mês de ${agenda.mesDescricao}? ${agenda.quantidadeHorariosAgendados > 0? 'O profissional possui horários agendados nesse mês':''}`}
            />
        </>
    )
    // --------------------------------------------------------
}

export default AgendaMesListItem